export const cardType = {
  DEAL_TEAM: "DEAL_TEAM",
};
